import {SERVER_URL} from '../utils/Constants';
import GeneralUtils from "../utils/GeneralUtils";

export default class ServiceMember {
    constructor(props) {
        this.baseURL = props;
    }

    async findAll() {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notificationPayNoAttention(error);
        });
    }

    async findAllByMerchantBranchId(merchantBranchId) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/merchantBranchId/" + merchantBranchId, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async findById(id) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/"+id, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async findAllActive() {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/status/active", {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async create(data) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL, {
            crossDomain: true,
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async createHiddenSuccess(data) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL, {
            crossDomain: true,
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async update(data) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL, {
            crossDomain: true,
            method: 'put',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        }).then(response => {
                let result = response.clone();
                GeneralUtils.notification(response);
                return GeneralUtils.responseToJson(result);
            }
        ).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async delete(id) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL +"/"+ id, {
            crossDomain: true,
            method: 'delete',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async updateStatus(id, status) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/"+ id + "/status/" + status, {
            crossDomain: true,
            method: 'put',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }




}